import { Form, Input } from 'antd';
import { JobOptionSvc } from 'domains/jobconfigDomain';
import { useOneofId } from '../hook/useOneofId';
import { IOneofProps } from '../OneOfSvcs';

const { TextArea } = Input;

interface Iprops extends IOneofProps {
  svc?: JobOptionSvc;
}

const CommonOneofSvcInstructions = (props: Iprops) => {
  const { disabled, svc } = props;

  const id = useOneofId(props);

  return (
    <>
      {/* className={`${svcDisabled ? 'jobconfig-jobOption-content-disabled' : ''}`} */}
      {Boolean(svc?.showInstructions) && (
        <>
          <div className={`jobconfig-jobOption-content-label`}>
            instructions
          </div>

          <div className={`jobconfig-jobOption-textArea`}>
            <Form.Item name={[id, 'instructions']} noStyle>
              <TextArea
                disabled={disabled}
                placeholder="Type instructions here"
              />
            </Form.Item>
          </div>
        </>
      )}
    </>
  );
};

export default CommonOneofSvcInstructions;
